export default __webpack_public_path__ + "static/media/strasbourg14.4dbebe56.jpg";